const OPEN_MODAL = 'platfi-ui-app/MODALS/OPEN_MODAL';
const CLOSE_MODAL = 'platfi-ui-app/MODALS/CLOSE_MODAL';

export { CLOSE_MODAL, OPEN_MODAL };
